<template>
<main class="container-right-nav">
    <div class="container-body">
      <!--Tabla de documentos-->
      <table class="docs-table">
        <!--Cabecera de tabla-->
        <thead>
          <tr>
            <th>#</th>
            <th class="sortable" @click="onSort('filename')">
              Nombre <font-awesome-icon :icon="getSortIcon('filename')"/>
            </th>
            <th class="sortable" @click="onSort('description')">
              Descripción <font-awesome-icon :icon="getSortIcon('description')"/>
            </th>
            <th class="sortable" @click="onSort('order')">
              Orden <font-awesome-icon :icon="getSortIcon('order')"/>
            </th>
            <th>
              Acción
            </th>
          </tr>
        </thead>
        <!--Cuerpo de tabla-->
        <tbody>
          <tr v-for="(item, index) in docs" :key="item.id">
            <td>{{ (currentPage - 1) * pageSize + index + 1 }}</td>
            <td>
              <a v-if="item.path" :href="contentUrl(item)" target="_blank" rel="noopener">
                {{ item.filename }}
              </a>
              <template v-else>{{ item.filename }}</template>
            </td>
            <td>{{ item.description }}</td>
            <td>{{ item.order }}</td>
            <td class="action-cell">
              <button class="btn-action btn-ver" :disabled="togglingId === item.id" @click="toggleVisibility(item)">
                <font-awesome-icon icon="eye" /> {{ item.es_visible ? 'Ocultar' : 'Mostrar' }}
              </button>
              <router-link :to="'/documentos/' + item.id + '/editar-documento'" class="btn-action btn-edit">
                Editar
              </router-link>
              <router-link :to="'/documentos/' + item.id + '/eliminar-documento'" class="btn-action btn-delete">
                Eliminar
              </router-link>
            </td>
          </tr>
          <!--Error-->
          <tr v-if="!hasDocuments">
            <td colspan="8">No hay documentos</td>
          </tr>
        </tbody>
      </table>
    </div>
    <SideNav class="container-sidenav" :links="routesNav" />
</main>
</template>
<script>
import SideNav from '@/components/SideNav.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import Pagination from '@/components/Pagination.vue'

import { formatter } from '@/components/mixin/formatter.js'
import { pagination } from '@/components/mixin/pagination.js'
import { restDocument } from '@/components/mixin/restDocument.js'

export default {
	mixins: [formatter, pagination, restDocument],
	components: { SideNav, Breadcrumb, Pagination },

	data (){
		return {
			loading: false,
			searchQuery: '',
			sortKey: '',
			sortOrder: 'asc',
			pageSize: 15,
			debounceTimer: null,
			togglingId: null,
		}
	},
  computed: {
    routesNav() {
      return [
        {name: 'Documentos'},
        {name:'Crear Documento', path:'/documentos/nuevo-documento'}
      ]
    },
    hasDocuments() {
      return this.docs.length > 0
    }
  },
  methods: {
    fetchDocuments() {
        this.getDocsPages(this.currentPage, this.searchQuery, this.sortKey, this.sortOrder, this.pageSize)
    },
    pageChangedClick(page) {
      this.currentPage = page
      this.fetchDocuments()
    },
    onChangeGroup(idGroup) {
      this.currentPage = 1
      this.selectedGroup = idGroup
      this.fetchDocuments()
    },
    onPageSizeChange() {
      this.currentPage = 1
      this.fetchDocuments()
    },
    onSearchKeyup() {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.currentPage = 1
        this.fetchDocuments()
      }, 300)
    },
    onSort(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortKey = key
        this.sortOrder = 'asc'
      }
      this.currentPage = 1
      this.fetchDocuments()
    },
    getSortIcon(key) {
      if (this.sortKey !== key) return 'sort'
      return this.sortOrder === 'asc' ? 'sort-up' : 'sort-down'
    },
    toggleVisibility(item) {
      this.togglingId = item.id
      this.toggleDocVisibility(item.id)
        .then(() => {
          this.$store.dispatch('toast/show', {
            message: item.es_visible ? 'Documento ocultado' : 'Documento ahora visible',
            type: 'info'
          })
          this.fetchDocuments()
        })
        .catch(() => {
          this.$store.dispatch('toast/show', {
            message: 'No es posible cambiar la visibilidad del documento',
            type: 'error'
          })
        })
        .finally(() => {
          this.togglingId = null
        })
    },
  },
  created () {
    this.$store.getters.getPermissions.documents ? true : this.$router.push('/pagina-no-encontrada')
  },
  mounted() {
    console.log("mounted...")
    this.fetchDocuments()
    console.log(this.docs)
  }

}
</script>
<style lang="scss" scoped>
.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1em;
  margin-bottom: 1em;
}

.toolbar-left,
.toolbar-center,
.toolbar-right{
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 0.75em;
}

.docs-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1em;
}
.docs-table th,
.docs-table td {
  padding: 0.6em 0.8em;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  text-align: left;
  vertical-align: middle;
  font-size: 0.875em;
}

.docs-table thead th {
  background: #004B7A;
  color: #fff;
  white-space: nowrap;
  font-weight: 600;
}

.docs-table th.sortable {
  cursor: pointer;
  user-select: none;
}

.docs-table th.sortable:hover {
  background: #006FB3;
}

.docs-table tbody tr:hover {
  background: rgba(0, 111, 179, 0.06);
}

.docs-table td.action-cell {
  white-space: nowrap;
}

.docs-table td.action-cell .btn-action + .btn-action {
  margin-left: 0.5em;
}

.docs-table td:nth-child(6),
.docs-table td:nth-child(7) {
  white-space: nowrap;
}
</style>
